import sign from './sign.js'
import healthy from './healthy.js'

const api = Object.assign({...sign}, {...healthy})
// 所有接口从这里走
export default api



// WEBPACK FOOTER //
// ./src/service/index.js